import { render } from "./LatestProducts.vue?vue&type=template&id=00b043dc"
import script from "./LatestProducts.vue?vue&type=script&lang=js"
export * from "./LatestProducts.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__